var exports = {
  "l": "Dialog__Nag9wu",
};

module.exports = exports;
